import { intersection, toString, uniq } from "lodash";

const CONTACT_REFERENCE = /^(buyer|contact|contractor|user):/;

// Every contact picked in to, cc or bcc. cc and bcc count as well: a message addressed to
// buyers only via bcc would otherwise offer every unit of the project and end up on a
// message thread without one, which makes it invisible in the buyer portal.
export const selectedContacts = message =>
  uniq([
    ...(message.recipients || []),
    ...(message.cc || []),
    ...(message.bcc || [])
  ]);

export const selectedBuyerIds = message =>
  selectedContacts(message)
    .filter(value => toString(value).indexOf("buyer:") === 0)
    .map(value => parseInt(toString(value).split(":")[1], 10));

// The units that hold every selected buyer. Buyers of several units leave no candidate,
// which is correct: such a message does not belong to a single unit.
export const unitOptionsFor = (message, units) => {
  const buyerIds = selectedBuyerIds(message);

  const candidates =
    buyerIds.length > 0
      ? units.filter(
          unit =>
            intersection(buyerIds, unit.buyer_ids).length === buyerIds.length
        )
      : units;

  return candidates
    .filter(unit => unit.project_id === parseInt(message.project_id, 10))
    .map(unit => ({
      key: unit.id,
      value: unit.id,
      text: unit.name
    }));
};

// Keeps the entries that are still selectable among the given option values. Free text
// addresses, which cc and bcc allow, are not bound to a project and are always kept.
export const contactsOfProject = (selected, availableValues) =>
  (selected || []).filter(
    value =>
      availableValues.includes(value) ||
      !CONTACT_REFERENCE.test(toString(value))
  );
